/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 0 = Other
 *
 * 1 = Parts
 *
 * 2 = Vehicles
 *
 * 3 = VehicleDelivery
 *
 * 4 = BuildingMaintenance
 *
 * 5 = ServiceEquipmentMaintenance
 *
 * 6 = ITAndNetwork
 *
 * 7 = SmartRepair
 *
 * 8 = VehicleAdditionalEquipment
 *
 * 9 = Uniform
 *
 * 10 = Stationary
 *
 * 11 = Bodywork
 *
 * 12 = EquipmentAndTools
 */
export enum SupplierTypeEnum {
  Other = 0,
  Parts = 1,
  Vehicles = 2,
  VehicleDelivery = 3,
  BuildingMaintenance = 4,
  ServiceEquipmentMaintenance = 5,
  ITAndNetwork = 6,
  SmartRepair = 7,
  VehicleAdditionalEquipment = 8,
  Uniform = 9,
  Stationary = 10,
  Bodywork = 11,
  EquipmentAndTools = 12,
}
